"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@material-ui/core");
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var react_redux_1 = require("react-redux");
var actions_1 = require("../../redux/reducers/account-reactivation/actions");
var PasswordResetForm_1 = __importDefault(require("../PasswordResetWidget/components/PasswordResetForm"));
var ReactivationContent_1 = __importDefault(require("./components/ReactivationContent"));
var styles_1 = __importDefault(require("./styles"));
var AccountReactivationScreen = function (_a) {
    var identifier = _a.identifier, disableAutofill = _a.disableAutofill;
    var theme = (0, core_1.useTheme)();
    var classes = (0, styles_1.default)(theme)();
    var t = (0, react_i18next_1.useTranslation)().t;
    var dispatch = (0, react_redux_1.useDispatch)();
    document.title = t('reactivation.title');
    var key = identifier;
    react_1.default.useEffect(function () {
        if (key)
            dispatch((0, actions_1.checkUnsuspendKey)(key));
        return function () {
            dispatch((0, actions_1.reset)());
        };
    }, [key, actions_1.checkUnsuspendKey]);
    var _b = (0, react_redux_1.useSelector)(function (state) { return state.accountReactivation; }), success = _b.success, unsuspendKeyValid = _b.unsuspendKeyValid, loading = _b.loading;
    var onFormSubmit = function (password) {
        dispatch((0, actions_1.reactivateAccountFinish)(key, password));
    };
    return (react_1.default.createElement("div", { className: classes.screen },
        react_1.default.createElement(core_1.Grid, { className: classes.container, container: true, justifyContent: "center", item: true, xs: 11, sm: 11, md: 8 },
            react_1.default.createElement(core_1.Card, { raised: true, className: classes.reactivationCard },
                react_1.default.createElement(core_1.CardContent, { className: classes.reactivationCardContent }, unsuspendKeyValid && !success ? (react_1.default.createElement(PasswordResetForm_1.default, { onSubmit: onFormSubmit, title: t('reactivation.form.title'), description: t('reactivation.form.description'), identifier: key, disableAutofill: disableAutofill })) : (react_1.default.createElement(ReactivationContent_1.default, { type: success ? 'success' : 'error', loading: loading })))))));
};
exports.default = AccountReactivationScreen;
//# sourceMappingURL=index.js.map